<div class="side-panel-container">
  <div class="info">
    <div class="title">
      <h3>
        {{ translate.get(taskDetail?.titleI18nKey) == taskDetail?.titleI18nKey ? taskDetail?.title :
        translate.get(taskDetail?.titleI18nKey) }}
        <tsl-icon class="manual-link" *ngIf="showDocumentHelpIcon()" (click)="showManual()">help</tsl-icon>
      </h3>
      <br />
      <div class="due-date"><span i18n="@@due" t="due">Due</span> {{taskDetail?.taskRequestMetadata?.dueDate | date: 'longDate':'':(language == "no-NO" ? "nn" : language)}}</div>
    </div>
    <button tsl-icon-button size="large" (click)="close()">
      <tsl-icon>close</tsl-icon>
    </button>
  </div>

  <!-- <srm-task *ngIf="enableWebComponent" [taskId]="taskDetail.portalTaskID" env="uat" auth-token-path="supplier-profile-stg:token"></srm-task> -->

  <!-- Context Veribiage -->
  <div *ngIf="taskDetail" class="task-container"
    [ngStyle]="{'padding': (enableWebComponent && taskDetail.taskStatus != 'Completed')? '0' : '15px 30px'}">

    <div *ngIf="taskDetail.taskStatus == 'Completed'; else OtherContact">
      <h3 i18n="@@taskCompletedMessage" t="taskCompletedMessage">Task is already completed please go back to home page.
      </h3>
    </div>

    <ng-template #OtherContact [ngSwitch]="taskDetail.subTaskType">
      <!-- SRM Task WebComponent -->
      <srm-task *ngIf="enableWebComponent; else ProfileTask" [env]="env" [locale]="language"
        [taskId]="taskDetail.portalTaskID" authTokenPath="{{authTokenPath}}" (taskCompleted)="onSave($event)">
      </srm-task>
      <!-- Profile Task Component -->
      <ng-template #ProfileTask>
        <div>
          <div *ngSwitchCase="'Details'">
            <app-detail-task-wrapper #detailsTask [supplierCode]="taskDetail.supplierCode"
              [taskId]="taskDetail.portalTaskID" [isSidePanelMode]="true" (onSave)="onSave($event)">
            </app-detail-task-wrapper>
          </div>
          <div *ngSwitchCase="'Address'">
            <app-address-task-wrapper #addressTask [enableExistSelection]="['entityExtension'].includes(onboardingType)" [isReactivation]="false" [supplierCode]="taskDetail.supplierCode"
              [taskId]="taskDetail.portalTaskID" [isSidePanelMode]="true" (onSave)="onSave($event)">
            </app-address-task-wrapper>
          </div>
          <div *ngSwitchCase="'AddressList'">
            <app-address-task-wrapper #addressTask [enableExistSelection]="true" [isReactivation]="true" [supplierCode]="taskDetail.supplierCode"
              [taskId]="taskDetail.portalTaskID" [isSidePanelMode]="true" (onSave)="onSave($event)">
            </app-address-task-wrapper>
          </div>
          <div *ngSwitchCase="'Contacts'">
            <app-contact-task-wrapper #contactTask [supplierCode]="taskDetail.supplierCode"
              [taskId]="taskDetail.portalTaskID" [isSidePanelMode]="true" (onSave)="onSave($event)">
            </app-contact-task-wrapper>
          </div>
          <div *ngSwitchCase="'Bank'">
            <app-bank-task-wrapper #bankTask [enableExistSelection]="['entityExtension'].includes(onboardingType)"
              [taskDetail]="taskDetail" [isReactivation]="false" [supplierCode]="taskDetail.supplierCode"
              [taskId]="taskDetail.portalTaskID"
              [isSidePanelMode]="true" (onSave)="onSave($event)"></app-bank-task-wrapper>
          </div>
          <div *ngSwitchCase="'BankList'">
            <app-bank-task-wrapper #bankTask [enableExistSelection]="true" [taskDetail]="taskDetail" [isReactivation]="true" [supplierCode]="taskDetail.supplierCode" [taskId]="taskDetail.portalTaskID"
              [isSidePanelMode]="true" (onSave)="onSave($event)"></app-bank-task-wrapper>
          </div>
          <div *ngSwitchCase="'Tax'">
            <app-tax-task-wrapper #taxTask [enableExistSelection]="['entityExtension'].includes(onboardingType)" [isReactivation]="false" [supplierCode]="taskDetail.supplierCode" [taskId]="taskDetail.portalTaskID"
              [isSidePanelMode]="true" (onSave)="onSave($event)"></app-tax-task-wrapper>
          </div>
          <div *ngSwitchCase="'TaxList'">
            <app-tax-task-wrapper #taxTask [enableExistSelection]="true" [isReactivation]="true" [supplierCode]="taskDetail.supplierCode" [taskId]="taskDetail.portalTaskID"
              [isSidePanelMode]="true" (onSave)="onSave($event)"></app-tax-task-wrapper>
          </div>
          <div *ngSwitchCase="'Diversity'">
            <app-diversity-task-wrapper #diversityTask [supplierCode]="taskDetail.supplierCode"
              [taskId]="taskDetail.portalTaskID" [isSidePanelMode]="true" (onSave)="onSave($event)">
            </app-diversity-task-wrapper>
          </div>
          <div *ngSwitchCase="'Insurance'">
            <app-insurance-task-wrapper #insuranceTask [supplierCode]="taskDetail.supplierCode" [taskId]="taskDetail.portalTaskID"
              [isSidePanelMode]="true" [isRequired]="true" (onSave)="onSave($event)"></app-insurance-task-wrapper>
          </div>
          <div *ngSwitchCase="'Domain'">
            <app-domain-task-wrapper #domainTask [supplierCode]="taskDetail.supplierCode" [taskId]="taskDetail.portalTaskID"
              (onSave)="onSave($event)"></app-domain-task-wrapper>
          </div>
          <div *ngSwitchCase="'MSME'">
            <app-msme-task-wrapper #msmeTask [supplierCode]="taskDetail.supplierCode" [taskId]="taskDetail.portalTaskID"
             [isSidePanelMode]="true" (onSave)="onSave($event)"></app-msme-task-wrapper>
          </div>
        </div>
      </ng-template>
    </ng-template>
  </div>
  <div *ngIf="!enableWebComponent || taskDetail.taskStatus == 'Completed'" class="footer">
    <button tsl-button size="medium" color="black" outline (click)="close()">{{ translate.get(cancelBtnLabel)
      }}</button>
    <!-- <button *ngIf="taskDetail?.taskStatus != 'Completed' && taskDetail.subTaskType == 'Bank'" tsl-button size="medium" color="blue" filled (click)="submit(true)" i18n="@@Save" t="Save">Save</button> -->
    <button *ngIf="taskDetail?.taskStatus && ['New', 'Rejected'].includes(taskDetail?.taskStatus)" tsl-button
      size="medium" color="blue" filled (click)="submit()">{{ translate.get(submitBtnLabel) }}</button>
  </div>
</div>
